// Shared constants exports

/**
 * Default image shown when a trip has no cover photo.
 * Hilltop vehicles / overlanding scene — https://unsplash.com/photos/two-vehicles-parked-on-a-hilltop-with-people-GpXJcT0U-3M
 */
export const DEFAULT_TRIP_COVER_URL = 'https://images.unsplash.com/photo-1761872802877-f4a229449340?w=1200&h=300&fit=crop&auto=format&q=80'
/**
 * Returns the trip cover URL to display, or the default cover when none is set.
 */
export function getTripCoverUrl(coverPhotoUrl: string | null | undefined): string {
  return coverPhotoUrl ?? DEFAULT_TRIP_COVER_URL
}
